import $ from 'jquery';
import {Functions as Functions} from '../../../helpers/functions';
import Log from '../../../helpers/log';
import {Component} from '../../../component';

export class Navbar extends Component {

    /**
     * setup
     */
    setup() {
        this.$document = $(document);
        this.$body = $('body');
        this.$navigation = $('.js-pwn-main-navigation');
        this.$openBtn = $('.js-pwn-toggle-navigation');
        this.$closeBtn = $('.js-pwn-close-toggle-navigation');

        this.$openBtn.on('click', (e) => {
            Functions.killEvent(e);
            this.show();
        });

        this.$closeBtn.on('click', (e) => {
            Functions.killEvent(e);
            this.close();
        });

        this.$document.on('click', (e) => {
            if (!this.$navigation.get(0).contains(e.target) && !this.$openBtn.get(0).contains(e.target)) {
                this.close();
            }
        });

        this.$document.off('click.bs.dropdown.data-api', '.navbar-toggle[data-toggle="dropdown"]');

        this.init();
    }

    /**
     * resize
     */
    // resize() {
        // this.init();
    // }

    /**
     * resize
     */
    init() {
        var $navigationDropdownToggle = this.$navigation.find('[data-toggle="dropdown"]');

        console.log(this.$navigation, 'this.$navigation');

        // if ($(window).width() < 992) {
            $navigationDropdownToggle.off('click.bs.dropdown').on('click.bs.dropdown', function (e) {
                Functions.killEvent(e);

                var $this = $(this);

                if ($this.is('.disabled, :disabled')) return;

                var $parent = $this.parent();
                var isActive = $parent.hasClass('open');
                var selector = $this.attr('href');

                selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7

                if (isActive && !selector) {
                    location.href = $this.attr('href');

                    return false;
                }

                var relatedTarget = {relatedTarget: this};

                if (!isActive) {
                    $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget));
                    // $parent.find( '> .dropdown-menu' ).stop( true, true ).slideDown( '350' );

                    $this
                        .trigger('focus')
                        .attr('aria-expanded', 'true')

                    $parent
                        .addClass('open')
                        .trigger($.Event('shown.bs.dropdown', relatedTarget))
                } else {
                    $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget));
                    // $parent.find( '> .dropdown-menu' ).stop( true, true ).slideUp( '350' );
                    $this.attr('aria-expanded', 'false');
                    $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget));
                }

                return false;
            });
        // }
    }

    /**
     * Show menu
     */
    show() {
        this.$body.addClass('menu-shown');
        this.$openBtn.addClass('js-pwn-close-toggle-navigation');
    }

    /**
     * Close menu
     */
    close() {
        this.$body.removeClass('menu-shown');
        this.$openBtn.removeClass('js-pwn-close-toggle-navigation');
    }
}
